import React, { useState, useRef, useEffect } from "react";
import InputDatePicker from "../InputFields/InputDatePicker/InputDateTimePickerMUI";
import InputDropDown from "../InputFields/InputDropDown/InputDropDown";
import InputMultiSelect from "../InputFields/InputMultiSelect/InputMultiSelect";
import InputText from "../InputFields/InputText/InputText";
import InputColor from "../InputFields/InputColor/InputColor";
import InputToggle from "../InputFields/InputToggle/InputToggle";
import Tabs from "../Tabs/Tabs";
import InputFile from "../InputFields/InputFile/InputFile";
import InputFileSingle from "../InputFields/InputFile/InputFileSingle";
import ClickableImage from "../ClickableImage/ClickableImage";
import RelatedCard from "../RelatedCard/RelatedCard";
import { useSelector, useDispatch } from "react-redux";
import InputSelectionPopup from "../InputFields/InputSelectionPopup/InputSelectionPopup";
import SimpleHeading from "../Headings/SimpleHeading";
import InputTextTwoLabels from "../InputFields/InputText/InputTextTwoLabels";
import SummaryList from "../List/SummaryList";
import SingleRelatedCard from "../RelatedCard/SingleRelatedCard";
import ESignature from "../ESignature/ESignature";
import FileFetcher from "../FileFetcher/FileFetcher";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import InputRichText from "../InputFields/InputText/InputRichText";
import InputPhoneDisplay from "../InputFields/InputText/InputPhoneDisplay";
import ErrorAlerts from "../Alerts/ErrorAlerts";
import { useBillingEventsLockStatus } from "../../hooks/useBillingEventsLockStatus";
import { updatepageHeader, resetpageHeader } from "../../redux/pageHeaderSlice";
import { updateShowFieldsByIndex } from "../../redux/showFieldsSlice";
import {
  resetrelatedFields,
  updateRelatedFieldsByParam,
} from "../../redux/relatedFieldsSlice";
import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";
import { config } from "../../utils/config";
import {
  extractFromObject,
  extractParameterValues,
  findDataInFields,
} from "../../utils/helperFuctions";
import ReservationSummary from "../Misc/ReservationSummary";
import AsyncButton from "../Button/AsyncButton";
import { setShowPopupTrue, updatenavPopup } from "../../redux/navPopupSlice";
import TextDisplay from "../InputFields/TextDisplay/TextDisplay";
import VehiclesDisplay from "../InputFields/VehiclesDisplay/VehiclesDisplay";
import InputTextTwoLabelsWithCalc from "../InputFields/InputText/InputTextTwoLabelsWithCalc";
import RelatedCardToggles from "../RelatedCard/RelatedCardToggles";
import ActionsList from "../List/ActionsList";
import CustomerStatement from "../../pages/CustomersPage/CustomerStatement";
import CollectionDisplay from "../InputFields/CollectionDisplay/CollectionDisplay";
import TemporaryRta from "../../pages/VehiclesPage/TemporaryRta";
import ContractsDisplay from "../../pages/VehiclesPage/ContractsDisplay";
import MultiFieldsDisplay from "../InputFields/MultiFieldsDisplay/MultiFieldsDisplay";
import CompanyVehicles from "../../pages/Settings/CompanyPage/CompanyVehicles";
import ContractGenerator from "../Contracts/ContractGenerator";
import LinkButton from "../InputFields/LinkButton/LinkButton";
const ReusableForm = ({
  fields,
  onSubmit,
  onCancel,
  tabsData,
  handleRelatedData,
  disabled,
  updateShowFields,
  summaryFields,
  hideSubmitActions,
  customHandleInput,
  id,
  onlyForm,
  forcedErrors,
  handleSingleCreateData,
  callPopUp,
  headerSaveBotton,
  disableConditionsFunction,
  hideCancel,
  stickySubmitActions,
  fromPopUp,
  reservationCode,
  isSaving,
  setIsSaving,
  renderHeaderRight,
  actionType,
  formType, // edit or add
}) => {
  const fieldsChanged = useSelector((state) => state.showFields);
  // console.log(fieldsChanged, "fieldsChanged in reusable form");
  const [singleRelatedFields, setSingleRelatedFields] = useState([]);
  const [singleRelatedFieldsFormData, setSingleRelatedFieldsFormData] =
    useState({});

  // const [isSaving, setIsSaving] = useState(false);
  const relatedFields = useSelector((state) => state.relatedFields);
  const dispatch = useDispatch();
  const formRef = useRef(null);

  // Refs to store latest callbacks and values without triggering re-renders
  const handleSubmitRef = useRef(null);
  const refreshLockStatusRef = useRef(null);
  const updateShowFieldsRef = useRef(null);
  const manualSubmitFormRef = useRef(null);
  const fieldsChangedRef = useRef(fieldsChanged);

  const initFormData = () => {
    return fields.reduce(
      (acc, field) => ({
        ...acc,
        [field.name]:
          field.type !== "toggle"
            ? field.defaultValue ?? ""
            : field.defaultValue ?? false,
      }),
      {}
    );
  };

  const initialErrors = fields.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const initialrequiredFields = fields.reduce(
    (acc, field) => ({ ...acc, [field.name]: field.isRequired || false }),
    {}
  );
  const currentRole = getCookie("_r");
  const isAdmin = process.env.REACT_APP_ADMIN_ROLE === currentRole;
  const isCaptain = process.env.REACT_APP_CAPTAIN_ID === currentRole;
  const isOperator = process.env.REACT_APP_OPERATOR_ROLE === currentRole;

  // Check billing events lock status for UI locking
  const isReservationPage = window.location.pathname.includes("/reservations/");
  const reservationId = isReservationPage ? id : null;
  const { lockStatus, isLocked, refreshLockStatus } = useBillingEventsLockStatus(
    fieldsChanged,
    reservationId
  );

  // State to trigger SequenceButton refresh after save
  const [sequenceButtonRefreshTrigger, setSequenceButtonRefreshTrigger] = useState(0);

  // Helper: Check if a field should be disabled due to billing event locking
  const isFieldLockedByBilling = (fieldName) => {
    // Map UI fields to billing event types
    const fieldToBillingEventType = {
      'rental_price': 'Rental Days',
      'rental_price_per_day': 'Rental Days',
      'mileage_amount': 'Mileage',
      'coverage_amount': 'Coverage',
      'discount': 'Discount',
      'delivery_charges': 'Delivery Charges',
      'security_deposit': 'Security Deposit',
    };

    // Fields that should ALWAYS be locked for everyone (including admin)
    // Keep these locked to preserve VAT allocation + avoid sequence/VAT errors.
    // (Includes all billing-event UI fields + tax/vat fields.)
    const alwaysLockedFields = [
      'rental_price',
      'rental_price_per_day',
      'vat',
      'vat_amount',
      'vat_rate',
      'tax',
      'tax_amount',
      'discount',
      'mileage_amount',
      'coverage_amount',
      'delivery_charges',
      'security_deposit',
    ];

    const billingEventType = fieldToBillingEventType[fieldName];
    if (billingEventType) {
      const lockInfo = lockStatus.rentalPricingTypes[billingEventType];
      const typeLocked = typeof lockInfo === 'boolean' ? lockInfo : lockInfo?.locked === true;

      if (!typeLocked) return false;

      // Always locked fields - no admin bypass
      if (alwaysLockedFields.includes(fieldName)) {
        return true;
      }

      // Check for non-credit-note negative amount - force lock
      if (typeof lockInfo === 'object' && lockInfo.is_credit_note === false && parseFloat(lockInfo.amount || 0) < 0) {
        return true;
      }

      // Admin can edit other fields
      if (isAdmin) {
        return false;
      }

      return true;
    }

    // Fields that should be locked when ANY rental pricing billing event is locked
    const autoCalcFields = ['auto_calculate'];
    if (autoCalcFields.includes(fieldName)) {
      return lockStatus.reservationLevel === true;
    }

    // Other reservation-level fields that depend on multiple billing events
    const otherReservationFields = ['extra_price_km', 'extra_kms_charge'];
    if (otherReservationFields.includes(fieldName)) {
      return lockStatus.reservationLevel === true;
    }

    return false;
  };
  const getTab = (tabsData) => {
    let tab = null;
    if (tabsData != null && (isCaptain || isOperator)) {
      tab = tabsData.find((tab) => tab.name === "Pickup");
    } else if (
      tabsData != null &&
      (process.env.REACT_APP_ADMIN_ROLE === currentRole ||
        process.env.REACT_APP_MANAGER_ROLE === currentRole ||
        process.env.REACT_APP_FINANCE_ROLE === currentRole)
    ) {
      tab = tabsData.find((tab) => tab.name === "Details");
    }
    return tab;
  };

  const pickupTab = 0;
  const [_currentTab, setCurrentTab] = useState(getTab(tabsData));

  const initShowFields = (_fields) => {
    if (_currentTab && _currentTab.fields) {
      return (_fields
        ? _currentTab.fields.map((e) => {
          const findField = _fields.find((x) => x.name === e);
          if (findField) {
            return findField;
          }
        })
        : _currentTab.fields.map((e) => {
          const findField = fields.find((x) => x.name === e);
          if (findField) {
            return findField;
          }
        })
      ).filter(Boolean); // Filter out undefined entries
    }

    let currentTab;
    if (tabsData && tabsData.length > 0) {
      currentTab = tabsData.find((obj) => obj.current === true);
    }

    if (currentTab && currentTab.fields) {
      return currentTab.fields.map((e) => {
        const findField = fields.find((x) => x.name === e);
        if (findField) {
          return findField;
        }
      }).filter(Boolean); // Filter out undefined entries
    }

    return fields;
  };

  const changeRequiredFields = (_fields) => {
    return _fields.reduce(
      (acc, field) => ({ ...acc, [field.name]: field.isRequired || false }),
      {}
    );
  };

  const [showFields, setShowFields] = useState(initShowFields());
  const [formData, setFormData] = useState(initFormData());

  const [errors, setErrors] = useState(initialErrors);

  const [hasFiles, setHasFiles] = useState(false);
  //const [summaryData,setsummaryData] = useState();
  const [requiredFields, setrequiredFields] = useState(initialrequiredFields);
  useEffect(() => {
    if (
      Array.isArray(fieldsChanged) &&
      fieldsChanged.length > 0 &&
      !fromPopUp
    ) {
      setShowFields(initShowFields(fieldsChanged));
      setFormData(initFormData());
      setrequiredFields(changeRequiredFields(fieldsChanged));
    }
  }, [fieldsChanged]);

  useEffect(() => {
    if (forcedErrors) {
      setErrors(forcedErrors);
    }
  }, [forcedErrors]);

  const tabChanged = (tab) => {
    if (tab && tab.fields) {
      setCurrentTab(tab);
      setShowFields(
        tab.fields.map((e) => {
          const findField = fields.find((x) => x.name === e);
          if (findField) {
            return findField;
          }
        }).filter(Boolean) // Filter out undefined entries
      );
    }
  };

  const handleInputChange = async (event, triggerPopup) => {
    console.log(triggerPopup);

    // for initial changes calculations ex : useeffect setting billing stuff after clicking billing tab
    if (triggerPopup !== false) {
      console.log("showp0", event.target.name);
      dispatch(setShowPopupTrue());
    }

    const { name, type, files, value, related, minParam, maxParam } =
      event.target;
    setErrors((prev) => {
      return {
        ...prev,
        [event.target.name]: "",
      };
    });

    if (type === "file") {
      setHasFiles(true);
      const newFormData = {
        ...formData,
        [name]: type === "file" ? files : value,
      };
      setFormData(newFormData);
      if (updateShowFields instanceof Function) {
        updateShowFields(newFormData, name);
      }
      if (customHandleInput instanceof Function) {
        customHandleInput(newFormData, name, type);
      }
    } else {
      let addToFormData = { [name]: value };
      // console.log(addToFormData, "adtfd");

      if (minParam) {
        const minValue = fieldsChanged.find(
          (x) => x.name === minParam
        )?.defaultValue;
        if (minValue) {
          const currentValue = new Date(
            value.includes("Z") || value.includes("+")
              ? new Date(value)
              : new Date(value + "Z")
          );
          const compareWith = new Date(
            minValue.includes("Z") || minValue.includes("+")
              ? new Date(minValue)
              : new Date(minValue + "Z")
          );
          if (
            !(isNaN(currentValue) || isNaN(compareWith)) &&
            !(compareWith < currentValue)
          ) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [name]: `${name} must be larger than ${minParam} `,
            }));
          }
        }
      } else if (maxParam) {
        const maxValue = fieldsChanged.find(
          (x) => x.name === maxParam
        )?.defaultValue;
        if (maxValue) {
          const currentValue = new Date(
            value.includes("Z") || value.includes("+")
              ? new Date(value)
              : new Date(value + "Z")
          );
          const compareWith = new Date(
            maxValue.includes("Z") || maxValue.includes("+")
              ? new Date(maxValue)
              : new Date(maxValue + "Z")
          );
          if (
            !(isNaN(currentValue) || isNaN(compareWith)) &&
            !(compareWith > currentValue)
          ) {
            // date picker must be less than related on input change
            // setErrors((prevErrors) => ({
            //   ...prevErrors,
            //   [name]: `${name} must be less than ${maxParam} `,
            // }));
          }
        }
      }

      if (
        event != null &&
        event.target != null &&
        event.target.others != null &&
        Array.isArray(event.target.others)
      ) {
        event.target.others.forEach((element) => {
          if (element.target?.name && element.target?.value) {
            addToFormData[element.target.name] = element.target.value;
          }
        });
      }
      //const newFormData = { ...formData, ...addToFormData}

      const newFormData = { ...formData, ...addToFormData };
      setFormData(newFormData);

      if (updateShowFields instanceof Function) {
        updateShowFields(newFormData, name, related);

        if (Array.isArray(event.others)) {
          event.others.forEach((element) => {
            if (element.target?.name && element.target?.value) {
              updateShowFields(newFormData, element.target.name);
            }
          });
        }
      } else if (fromPopUp === true) {
        // Keep popup-local showFields in sync so filters/lazyload react to changes
        setShowFields((prev) => {
          const updated = prev.map((f) =>
            f.name === name ? { ...f, defaultValue: value, changed: true } : f
          );
          if (Array.isArray(event.others)) {
            event.others.forEach((element) => {
              if (element.target?.name && element.target?.value) {
                const idx = updated.findIndex(
                  (x) => x.name === element.target.name
                );
                if (idx !== -1) {
                  updated[idx] = {
                    ...updated[idx],
                    defaultValue: element.target.value,
                    changed: true,
                  };
                }
              }
            });
          }
          return updated;
        });
      }
      if (customHandleInput instanceof Function) {
        customHandleInput(newFormData, name, type);
      }
      if (disableConditionsFunction instanceof Function) {
        disableConditionsFunction(name, value);
      }
    }
  };

  const handleRelatedField = (data, name, action, subname) => {
    if (handleRelatedData instanceof Function) {
      handleRelatedData(data, name, action, subname);
      console.log("showpp");

      dispatch(setShowPopupTrue());
    }
  };

  const handleSingleCreateField = (name) => {
    if (handleSingleCreateData instanceof Function) {
      handleSingleCreateData(name);
      console.log("showpp2");
      dispatch(setShowPopupTrue());
    }
  };

  const handleDeleteFile = (file) => {
    const tempdf = relatedFields?.deleteFiles;
    dispatch(
      updateRelatedFieldsByParam({
        paramName: "deleteFiles",
        value: tempdf ? [...tempdf, file] : [file],
      })
    );
    const tempFD = formData?.deleteFiles;
    setFormData({
      ...formData,
      deleteFiles: tempFD ? [...tempFD, file] : [file],
    });
  };

  // const handleOtherImageChange = (e) => {
  //   const { files } = e.target;
  //   setFormData({
  //     ...formData,
  //     otherImages: [...formData.otherImages, ...files],
  //   });
  // };

  // const removeOtherImage = (index) => {
  //   const updatedOtherImages = [...formData.otherImages];
  //   updatedOtherImages.splice(index, 1);
  //   setFormData({
  //     ...formData,
  //     otherImages: updatedOtherImages,
  //   });
  // };

  const validateField = async (name, value, customFields) => {
    const field = customFields
      ? customFields.find((f) => f.name === name)
      : fromPopUp
        ? fields.find((f) => f.name === name)
        : fieldsChanged.find((f) => f.name === name);
    let isError = false;
    var errorMessage = "";
    let isRequired = field?.isRequired || false;

    if (field && isRequired) {
      switch (field.type) {
        case "number":
          isError = isNaN(parseFloat(value));
          break;
        case "email":
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (field.validation) {
            if (field.validation.url) {
              if (field.validation.body) {
                let bodyObj = { ...field.validation.body };
                for (const key of Object.keys(bodyObj)) {
                  if (bodyObj.hasOwnProperty(key)) {
                    bodyObj[key] = extractFromObject(formData, bodyObj[key]);
                  }
                }
                const resp = await axios
                  .post(
                    config.apiUrl + "/api/" + field.validation.url,
                    bodyObj,
                    { headers: { Authorization: `Bearer ${getCookie("_AT")}` } }
                  )
                  .catch((e) => {
                    console.log(e);
                  });
                let confirmed = resp ? true : false;
                if (confirmed && field.validation.confirmation) {
                  let confirmObj = { ...field.validation.confirmation };
                  let respp = resp.data;
                  for (const key of Object.keys(confirmObj)) {
                    if (
                      confirmObj.hasOwnProperty(key) &&
                      respp.hasOwnProperty(key)
                    ) {
                      if (confirmObj[key] !== respp[key]) {
                        confirmed = false;
                        break;
                      }
                    }
                  }
                }

                if (!confirmed) {
                  errorMessage = "The email already exists";
                  isError = true;
                }
              }
            }
          }

          isError = isError || !regex.test(value);
          break;
        case "phone":
          const match = value.match(/\((.*?)\) (.*)/);
          if (match && match.length === 3) {
            if (!(match[1] && match[2])) {
              isError = true;
            }
          }
          break;
        case "dropdown":
          isError = field.returnObject
            ? Object.keys(value).length <= 0
            : typeof value === "string"
              ? value.trim() === ""
              : value === null || value === undefined;
          break;
        case "multiSelect":
        case "file":
        case "card":
          isError = Array.isArray(value) ? value.length <= 0 : true;
          break;
        case "datepicker":
          if (formData[field.name] === "") {
            isError = true;
          }
          if (field.minDate) {
            const value = formData[field.name] || "";
            const minValue =
              (customFields
                ? customFields.find((f) => f.name === field.minDate)
                  ?.defaultValue
                : fields.find((f) => f.name === field.minDate)?.defaultValue) ||
              "";
            const currentValue = new Date(
              value.includes("Z") || value.includes("+")
                ? new Date(value)
                : new Date(value + "Z")
            );
            const compareWith = new Date(
              minValue.includes("Z") || minValue.includes("+")
                ? new Date(minValue)
                : new Date(minValue + "Z")
            );
            if (
              !(isNaN(currentValue) || isNaN(compareWith)) &&
              !(compareWith < currentValue)
            ) {
              errorMessage = `${field.name} must be larger than ${field.minDate} `;
              isError = true;
            }
          } else if (field.relatedWith) {
            const value = formData[field.name] || "";
            const maxValue =
              (customFields
                ? customFields.find((f) => f.name === field.relatedWith)
                  ?.defaultValue
                : fields.find((f) => f.name === field.relatedWith)
                  ?.defaultValue) || "";
            const currentValue = new Date(
              value.includes("Z") || value.includes("+")
                ? new Date(value)
                : new Date(value + "Z")
            );
            const compareWith = new Date(
              maxValue.includes("Z") || maxValue.includes("+")
                ? new Date(maxValue)
                : new Date(maxValue + "Z")
            );
            if (
              !(isNaN(currentValue) || isNaN(compareWith)) &&
              !(compareWith > currentValue)
            ) {
              errorMessage = `${field.name} must be less than ${field.relatedWith} `;
              isError = true;
            }
          } else {
            isError =
              typeof value === "string"
                ? value.trim() === ""
                : value === null || value === undefined;
          }
          break;
        case "singleRelatedCard":
          let checkValue = "";
          if (field.relatedParam2) {
            checkValue = formData[field.relatedParam2];
          } else {
            checkValue = value;
          }

          if (checkValue) {
            if (!checkValue.id) {
              const newErrors = {};
              field.fields.forEach(async (f) => {
                const fieldError = await validateField(
                  f.name,
                  checkValue[f.name],
                  field.fields
                );
                newErrors[f.name] = fieldError;
              });

              isError = !Object.values(newErrors).every(
                (error) => error === ""
              );
              if (isError) {
                return newErrors;
              }
            }
          } else {
            isError = true;
          }
          break;
        default:
          isError =
            typeof value === "string"
              ? value.trim() === ""
              : value === null || value === undefined;
          break;
      }
      //#anchir
      if (isError) {
        return errorMessage || field.err || "Field is required";
      }
      // Add more validation rules as needed
    }
    return "";
  };

  const handleFieldBlur = (event) => {
    const { name, value } = event.target;
    const fieldError = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  const handleSubmit = async (event, stay, checkForIds) => {
    event?.preventDefault();

    const newErrors = {};
    const fieldToSkipValidationOnPickupPage = [
      "initial_odometer",
      "pickup_fuel_level",
    ];
    const fieldToSkipValidationOnReturnPage = [
      "return_odometer",
      "return_fuel_level",
    ];
    for (const field of fields) {
      if (_currentTab != null) {
        if (_currentTab.name !== "Pickup") {
          if (fieldToSkipValidationOnPickupPage.includes(field.name)) {
            continue;
          }
        }
        if (_currentTab.name !== "Return") {
          if (fieldToSkipValidationOnReturnPage.includes(field.name)) {
            continue;
          }
        }
      }
      // odometer + the rest will be handled diffrently
      if (
        field.name === "initial_odometer" ||
        field.name === "pickup_fuel_level" ||
        field.name === "return_odometer" ||
        field.name === "return_fuel_level"
      ) {
        continue;
      }
      const fieldError = await validateField(field.name, formData[field.name]);
      newErrors[field.name] = fieldError;
    }
    // work around for some fields
    if (
      _currentTab != null &&
      _currentTab.name === "Pickup" &&
      checkForIds === true // finalize pickup / return example
    ) {
      const fieldsToCheck = [
        {
          contactCard: [
            "id_number",
            "id_number_expiry",
            "driver_license_number",
            "driver_license_expiry",
          ],
        },
      ];

      fieldsToCheck.forEach((field) => {
        Object.entries(field).forEach(([key, value]) => {
          const parentField = singleRelatedFields.find((f) =>
            f.hasOwnProperty(key)
          );

          value.forEach((item) => {
            const field = parentField[key].find((field) => field.name === item);
            let formDataKeyName = "";
            if (key === "contactCard") {
              formDataKeyName = "contact";
            } else if (key === "vehicleCard") {
              formDataKeyName = "vehicle";
            }

            const formvalueEmpty =
              singleRelatedFieldsFormData[field?.name] == null ||
              (singleRelatedFieldsFormData[field?.name] != null &&
                typeof singleRelatedFieldsFormData[field?.name] === "string" &&
                singleRelatedFieldsFormData[field?.name].trim() === "");

            const defaultValueEmpty =
              // field.defaultValue == null ||
              field?.defaultValue === null ||
              (typeof field?.defaultValue === "string" &&
                field.defaultValue.trim() === "");

            if (formvalueEmpty && defaultValueEmpty) {
              newErrors[field?.name] = `${field.name
                .split("_")
                .join(" ")} is required`;
            } else if (
              singleRelatedFieldsFormData[field?.name] != null &&
              formvalueEmpty &&
              !defaultValueEmpty
            ) {
              newErrors[field.name] = `${field?.name
                .split("_")
                .join(" ")} is required`;
            } else if (
              field?.validateExpiry != null &&
              field?.validateExpiry != null &&
              field?.validateExpiry === true
            ) {
              let value = field?.defaultValue;
              if (singleRelatedFieldsFormData[field?.name] != null) {
                value = singleRelatedFieldsFormData[field?.name];
              }
              const selectedDate = new Date(value);
              const todaysDate = new Date();
              if (selectedDate < todaysDate) {
                newErrors[field.name] = `${field?.label.split(" ")[0]} ${field?.label.split(" ")[1]
                  } expired`;
              }
            } else {
              newErrors[field?.name] = "";
            }
          });
        });
      });
      console.log(newErrors, "newErrors");

      // check vehicle insurance expiration on finalize
      const isInsuranceExpired = await axios
        .get(config.apiUrl + "/api/reservations/insurancechecker/" + id, {
          headers: { Authorization: `Bearer ${getCookie("_AT")}` },
        })
        .catch((e) => {
          console.log(e);
        });
      if (isInsuranceExpired.data !== false) {
        newErrors["insurance_expired"] = isInsuranceExpired.data;
      } else {
        newErrors["insurance_expired"] = "";
      }
      console.log(isInsuranceExpired, "d");
    }

    setErrors(newErrors);
    const isValid = Object.values(newErrors).every((error) => error === "");

    if (isValid) {
      const response = await onSubmit(formData, hasFiles, stay || true);

      setFormData(initFormData());
      setErrors(initialErrors);

      // Trigger SequenceButton refresh after successful save
      setSequenceButtonRefreshTrigger((prev) => prev + 1);

      return response;
    } else {
      if (callPopUp instanceof Function) {
        const sendErrors = Object.values(newErrors).filter((x) => x !== "");
        callPopUp({
          title: "",
          description: "",
          isError: true,
          showPopUp: true,
          hideCancel: true,
          children: (
            <ErrorAlerts title={"Validation Error"} list={sendErrors} />
          ),
        });
      }

      return false;
    }
  };

  useEffect(() => { }, [formData]);
  useEffect(() => { }, [showFields]);

  // Keep refs updated with latest callbacks and values
  useEffect(() => {
    handleSubmitRef.current = handleSubmit;
    refreshLockStatusRef.current = refreshLockStatus;
    updateShowFieldsRef.current = updateShowFields;
    manualSubmitFormRef.current = manualSubmitForm;
    fieldsChangedRef.current = fieldsChanged;
  });

  const manualSubmitForm = () => {
    formRef?.current.click();
  };

  // Compute boolean values for billing cycle toggle so effect dependencies are stable primitives
  const showBillingCycleToggle = isReservationPage;
  const rawBillingCycle = isReservationPage ? findDataInFields(fieldsChanged, "billing_cycle.defaultValue", true) : null;
  const billingCycleValue = rawBillingCycle === true;
  const statusValue = isReservationPage ? findDataInFields(fieldsChanged, "status.defaultValue", true) : null;
  const billingCycleEnabled = statusValue === "Picked up";

  useEffect(() => {
    if (headerSaveBotton === true && formRef != null) {
      // Check if we're on customers, reservations or companies page
      const isCustomerPage = window.location.pathname.includes("/customers/");
      const isCompanyPage = window.location.pathname.includes("/companies/");

      //Always show sequence button on customers or reservations page for certain roles
      const showSequenceButton = (isCustomerPage || isReservationPage || isCompanyPage) &&
        (process.env.REACT_APP_ADMIN_ROLE === currentRole ||
          process.env.REACT_APP_FINANCE_ROLE === currentRole ||
          process.env.REACT_APP_MANAGER_ROLE === currentRole);

      const headerConfig = {
        addButton: true,
        buttonText: onlyForm ? (
          ""
        ) : (
          <>
            <ArrowLeftIcon className="w-5 inline-block" />
            <span>Exit</span>
          </>
        ),
        buttonFunction: () => {
          dispatch(updatenavPopup({ backClicked: true }));
          dispatch(resetpageHeader()); // Clear header buttons immediately on exit
        },
        secondaryButton: true,
        secondaryButtonText: "Save",
        secondaryButtonFunction: () => manualSubmitFormRef.current?.(),
        sequenceButton: showSequenceButton,
        sequenceButtonProps: showSequenceButton ? {
          contactId: isCustomerPage ? id : null,
          reservationId: isReservationPage ? id : null,
          companyId: isCompanyPage ? id : null,
          handleSubmit: (...args) => handleSubmitRef.current?.(...args),
          refreshTrigger: sequenceButtonRefreshTrigger,
          onSequenced: async (result) => {
            // Refresh lock status if available - use ref to get latest function
            if (refreshLockStatusRef.current && typeof refreshLockStatusRef.current === 'function') {
              await refreshLockStatusRef.current();
            }
            if (isCompanyPage) {
              window.location.reload();
            }
          }
        } : null,
        // Billing cycle toggle props
        billingCycleToggle: showBillingCycleToggle,
        billingCycleValue,
        billingCycleEnabled,
        onBillingCycleChange: showBillingCycleToggle
          ? (newValue) => {
              if (!billingCycleEnabled) return;
              // Find the index of the billing_cycle field in Redux showFields using ref
              const currentFields = fieldsChangedRef.current || [];
              const bcIndex = currentFields.findIndex((f) => f.name === "billing_cycle");
              if (bcIndex >= 0) {
                dispatch(
                  updateShowFieldsByIndex({
                    index: bcIndex,
                    toChange: { ...currentFields[bcIndex], defaultValue: newValue, changed: true },
                  })
                );
              }
              setFormData((prev) => ({ ...prev, billing_cycle: newValue }));
              if (updateShowFieldsRef.current instanceof Function) {
                updateShowFieldsRef.current({ billing_cycle: newValue }, "billing_cycle");
              }
              // Re-dispatch pageHeader so the toggle reflects the new value immediately
              dispatch(updatepageHeader({ billingCycleValue: newValue }));
            }
          : null,
      };

      dispatch(updatepageHeader(headerConfig));
    }
  }, [
    headerSaveBotton,
    id,
    onlyForm,
    currentRole,
    isReservationPage,
    sequenceButtonRefreshTrigger,
    billingCycleValue,
    billingCycleEnabled,
    dispatch,
  ]);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Load from localStorage, default to true (collapsed)
    const savedState = localStorage.getItem("reservationSummaryCollapsed");
    return savedState === null ? true : JSON.parse(savedState);
  });

  const toggleCollapsed = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    // Save to localStorage for persistence
    localStorage.setItem(
      "reservationSummaryCollapsed",
      JSON.stringify(newState)
    );
  };

  return (
    <>
      <Tabs
        currentFields={fieldsChanged}
        tabsData={tabsData}
        tabChanged={tabChanged}
        handleSubmit={handleSubmit}
        errors={errors}
        renderRight={(currentTab) =>
          typeof renderHeaderRight === "function"
            ? renderHeaderRight(currentTab)
            : null
        }
      />
      {/* TODO : handle correctly*/}
      {_currentTab != null &&
        (_currentTab.name === "Pickup" ||
          _currentTab.name === "Return" ||
          _currentTab.name === "Billing" ||
          _currentTab.name === "Details" ||
          _currentTab.name === "Vehicle") &&
        window.location.pathname.includes("/reservations/") && (
          <ReservationSummary
            id={id}
            currentTab={_currentTab}
            fields={fieldsChanged}
            isCollapsed={isCollapsed}
            toggleCollapsed={toggleCollapsed}
            isSaving={isSaving}
          />
        )}
      <div className="flex flex-col sm:flex-row gap-4">
        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className={`grid grid-cols-1 gap-x-6 ${_currentTab?.noGap ? "" : "gap-y-8"
            } sm:grid-cols-4 md:grid-cols-6 grow`}
        >
          {
            <div
              className={`sticky top-0 col-span-full z-20 bg-white ${!hideSubmitActions && stickySubmitActions ? "" : "hidden"
                }`}
            >
              <div className={`flex items-center justify-end gap-x-6 `}>
                {!onlyForm && !hideCancel && (
                  <button
                    type="button"
                    onClick={onCancel}
                    className="text-sm font-semibold leading-6 text-gray-900 relative"
                  >
                    <ArrowLeftIcon className="w-7 inline-block" />{" "}
                    <span>Back</span>
                  </button>
                )}

                <button
                  ref={formRef}
                  type="submit"
                  onClick={handleSubmit}
                  className={`rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${disabled ? "hidden" : ""
                    }`}
                >
                  Save
                </button>
              </div>
            </div>
          }

          {showFields.filter(Boolean).map((field) => {
            // console.log(field, "asdasdasdasd");

            // Skip if field is undefined or null
            if (!field) return null;

            return (
              <div
                key={field.name}
                className={`${field?.span
                  ? field.span === 2
                    ? `col-span-full sm:col-span-4  asd ${field.mdSpan != null
                      ? `md:col-span-${field.mdSpan} lg:col-span-3`
                      : "md:col-span-3"
                    }`
                    : field.span === 3
                      ? "col-span-full sm:col-span-2"
                      : field.span === 4
                        ? "col-span-full sm:col-span-4"
                        : "col-span-full"
                  : "col-span-full sm:col-span-4 md:col-span-3"
                  } ${field.hide != null && field.hide === true ? "hidden" : ""}`}
              >
                {(field.type === "text" ||
                  field.type === "email" ||
                  field.type === "number") && (
                    <InputText
                      disableWhenFieldsAreFilled={
                        field.disableWhenFieldsAreFilled
                      }
                      disableEditForNonAdmin={field.disableEditForNonAdmin}
                      formType={formType}
                      currentRole={currentRole}
                      converter={field.converter}
                      display={field.display}
                      step={field.step}
                      hideComponent={field.hideComponent}
                      disabledIfField={field.disabledIfField}
                      label={field.label}
                      type={field.type}
                      name={field.name}
                      err={errors[field.name]}
                      handleChange={handleInputChange}
                      defaultValue={field.defaultValue}
                      hide={field.hide}
                      lazyloadUrl={field.lazyloadUrl}
                      lazyloadParam={field.lazyloadParam}
                      lazyloadFieldChange={field.lazyloadFieldChange}
                      body={field.body}
                      decimalCount={field.decimalCount}
                      minValue={field.minValue}
                      maxValue={field.maxValue}
                      required={requiredFields[field.name]}
                      disabled={disabled || field.disabled || isFieldLockedByBilling(field.name)}
                    />
                  )}
                {/* {field.type === "extras" && <div>extras</div>} */}
                {field.type === "phone" && (
                  <InputPhoneDisplay
                    label={field.label}
                    type={field.type}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    disabled={disabled}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "textDisplay" && (
                  <TextDisplay
                    label={field.label}
                    type={field.type}
                    name={field.name}
                    displayValue={field.displayValue}
                    displayValue2={field.displayValue2}
                    fields={fieldsChanged}
                  />
                )}
                {field.type === "multiFieldsDisplay" && (
                  <MultiFieldsDisplay
                    label={field.label}
                    type={field.type}
                    name={field.name}
                    displayFields={field.displayFields}
                    fields={fieldsChanged}
                  />
                )}
                {field.type === "richtext" && (
                  <InputRichText
                    label={field.label}
                    type={field.type}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    disabled={disabled}
                    switchField={field.switchField}
                    switchFieldDefault={
                      showFields?.find((x) => x.name === field.switchField)
                        ?.defaultValue ?? "code"
                    }
                    // lazyloadUrl={field.lazyloadUrl}
                    // lazyloadParam={field.lazyloadParam}
                    // lazyloadFieldChange={field.lazyloadFieldChange}
                    // body={field.body}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "dropdown" && (
                  <InputDropDown
                    formType={formType}
                    currentRole={currentRole}
                    disableEditForNonAdmin={field.disableEditForNonAdmin}
                    actionType={actionType}
                    disableOnAction={field.disableOnAction}
                    disableXButton={field.disableXButton}
                    fromPopup={fromPopUp}
                    currentFieldsOverride={fromPopUp ? showFields : undefined}
                    isFieldReadOnly={field.isFieldReadOnly}
                    editId={id}
                    defaultOnNew={field.defaultOnNew}
                    returnDataAsIs={field.returnDataAsIs}
                    displayTextOnly={field.displayTextOnly}
                    disabledIfField={field.disabledIfField}
                    isSaving={field.refetchOnSave != null ? isSaving : null}
                    setIsSaving={setIsSaving != null ? setIsSaving : null}
                    refetchOnSave={field.refetchOnSave}
                    removeElementIfPreviouslyAdded={
                      field.removeElementIfPreviouslyAdded || false
                    }
                    fieldParentName={field.fieldParentName}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    placeholder={field.placeholder}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    data={field.data ?? []}
                    returnID={field.returnID}
                    lazyloadUrl={field.lazyloadUrl}
                    lazyloadParamName={field.lazyloadParamName}
                    lazyloadParam={field.lazyloadParam}
                    lazyloadParam2={field.lazyloadParam2}
                    lazyloadParam3={field.lazyloadParam3}
                    concat={field.concat}
                    concatBy={field.concatBy}
                    returnObject={field.returnObject}
                    disabled={disabled ? disabled : field.disabled}
                    showParameter={field.showParameter}
                    addNew={field.addNew}
                    handleCreate={handleSingleCreateField}
                    defaultsTo={field.defaultsTo}
                    hide={field.hide || (field.hideNew && !id)}
                    required={requiredFields[field.name]}
                    filters={field.filters}
                    lazyloadFieldChange={field.lazyloadFieldChange}
                    exclude={field.exclude}
                    nameTransformer={
                      typeof field.nameTransformer === "string" &&
                        field.nameTransformer.startsWith("<const>")
                        ? undefined
                        : field.nameTransformer
                    }
                  />
                )}
                {field.type === "multiSelect" && (
                  <InputMultiSelect
                    label={field.label}
                    name={field.name}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    options={field.data}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "datepicker" && (
                  <InputDatePicker
                    disableInput={field.disableInput}
                    useMaxDateTheDefaultValueIf={
                      field.useMaxDateTheDefaultValueIf
                    }
                    reduceMinDateDays={field.reduceMinDateDays}
                    minValueFromObj={field.minValueFromObj}
                    minValueFrom={field.minValueFrom}
                    disabledIfField={field.disabledIfField}
                    isItPickup={field.isItPickup}
                    countryBranchCode={field.countryCode}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    minDate={field.minDate}
                    relatedWith={field.relatedWith}
                    isClearable={field.isClearable}
                    disabled={disabled ? disabled : field.disabled}
                    allowTime={field.allowTime}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "color" && (
                  <InputColor
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "collection_display" && (
                  <CollectionDisplay
                    name={field.name}
                    currentFields={fieldsChanged}
                    withDefault={field.withDefault}
                  />
                )}
                {field.type === "toggle" && (
                  <InputToggle
                    disableEditForNonAdmin={field.disableEditForNonAdmin}
                    formType={formType}
                    currentRole={currentRole}
                    disableAutoCalculateOnToggleOn={
                      field.disableAutoCalculateOnToggleOn
                    }
                    switchToFalseIfDisabled={field.switchToFalseIfDisabled}
                    alwaysEnabledIf={field.alwaysEnabledIf}
                    disabledIfNotField={field.disabledIfNotField}
                    customFontWeight={field.customFontWeight}
                    padding={field.padding}
                    singleLine={field.singleLine}
                    currentFields={fieldsChanged}
                    disabledIfField={field.disabledIfField}
                    disabled={field.disabled || isFieldLockedByBilling(field.name)}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    required={requiredFields[field.name]}
                    popupOnToggle={field.popupOnToggle}
                    id={id}
                  />
                )}
                {field.type === "whitespace" && <span></span>}
                {field.type === "vehiclesDisplay" && (
                  <VehiclesDisplay
                    removeValueOnWhichFieldValueChange={
                      field.removeValueOnWhichFieldValueChange
                    }
                    fields={fieldsChanged}
                    dataParam={field.dataParam}
                    disabledIfField={field.disabledIfField}
                    disabled={field.disabled}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    placeholder={field.placeholder}
                    url={field.url}
                    filters={field.filters}
                    dependson={field.dependson}
                    returnParameter={field.returnParameter}
                    toShow={field.toShow}
                    data={field.data}
                    isSearchable={field.isSearchable}
                    statusColors={field.statusColors}
                    searchPlaceholder={field.searchPlaceholder}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "popupSelection" && (
                  <InputSelectionPopup
                    removeValueOnWhichFieldValueChange={
                      field.removeValueOnWhichFieldValueChange
                    }
                    dataParam={field.dataParam}
                    disabledIfField={field.disabledIfField}
                    disabled={field.disabled}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    placeholder={field.placeholder}
                    url={field.url}
                    filters={field.filters}
                    dependson={field.dependson}
                    returnParameter={field.returnParameter}
                    toShow={field.toShow}
                    data={field.data}
                    isSearchable={field.isSearchable}
                    statusColors={field.statusColors}
                    searchPlaceholder={field.searchPlaceholder}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "file" && field.isMulti && (
                  <InputFile
                    label={field.label}
                    name={field.name}
                    currentFields={fieldsChanged}
                    disabled={field.disabled}
                    disabledIfField={field.disabledIfField}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    handleDeleteFiles={handleDeleteFile}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "file" && field.isMulti === false && (
                  <InputFileSingle
                    currentFields={fieldsChanged}
                    disabled={field.disabled}
                    disabledIfField={field.disabledIfField}
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    handleDeleteFiles={handleDeleteFile}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "clickableImage" && (
                  <ClickableImage
                    currentFields={fieldsChanged}
                    disabled={field.disabled}
                    disabledIfField={field.disabledIfField}
                    imageClicked={handleRelatedField}
                    name={field.related}
                    clicks={
                      showFields?.find((x) => x.name === field.related)
                        ?.defaultValue ?? []
                    }
                    parentId={field.parentId ? id : ""}
                    parentParamName={field.parentParamName}
                    adddata={field.data}
                    exclude={field.exclude}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "cardToggles" && (
                  <RelatedCardToggles
                    id={id}
                    currentFields={fieldsChanged}
                    defaultValue={field.defaultValue}
                    label={field.label}
                    name={field.name}
                    disabledIfField={field.disabledIfField}
                    url={field.url}
                    disabled={field.disabled}
                    currentTab={_currentTab}
                    body={field.body}
                    fields={fieldsChanged}
                    handleChange={handleRelatedField}
                    handleInputChange={handleInputChange}
                  />
                )}
                {field.type === "card" && (
                  <RelatedCard
                    useIndexAsKey={field.useIndexAsKey}
                    handleSubmit={handleSubmit}
                    callPopUp={callPopUp}
                    disableWhenDayEnds={field.disableWhenDayEnds}
                    scroll={field.scroll}
                    lazyload={field.lazyload}
                    lazyloadParam={field.lazyloadParam}
                    calculateTotalAmount={field.calculateTotalAmount}
                    removeValueOnWhichFieldValueChange={
                      field.removeValueOnWhichFieldValueChange
                    }
                    removeItem={field.removeItem}
                    disabledIfField={field.disabledIfField}
                    disabledIfField2={field.disabledIfField2}
                    disabled={field.disabled}
                    clearDataOnBranchChange={field.clearDataOnBranchChange}
                    label={field.label}
                    name={field.name}
                    limit={field.limit}
                    subname={field.subname}
                    err={errors[field.name]}
                    handleChange={handleRelatedField}
                    handleInputChange={handleInputChange}
                    defaultValue={
                      field.subname
                        ? fieldsChanged.find((x) => x.name === field.subname)
                          ?.defaultValue
                        : field.defaultValue
                    }
                    showAction={field.showAction}
                    mainAction={field.mainAction}
                    rowActions={field.rowActions}
                    rowActionsShowNew={field.rowActionsShowNew}
                    toShow={field.toShow}
                    headerAction={field.headerAction}
                    inputField={field.inputField}
                    exclude={field.exclude}
                    addBarier={field.addBarier}
                    affectList={field.affectList}
                    lockStatus={lockStatus}
                    isLocked={isLocked}
                    required={requiredFields[field.name]}
                    className={field.className + " mt-8"}
                    id={id}
                    onlyLatestCanBeDeleted={field.onlyLatestCanBeDeleted}
                  />
                )}
                {field.type === "simpleHeading" && (
                  <SimpleHeading
                    secondValueNextToCode={field.secondValueNextToCode}
                    fields={fieldsChanged}
                    label={field.label}
                    showReservationCodeAndStatus={
                      field.showReservationCodeAndStatus
                    }
                    reservationCode={reservationCode}
                  />
                )}
                {field.type === "singleRelatedCard" && (
                  <SingleRelatedCard
                    editId={id}
                    setSingleRelatedFields={(fields) => {
                      setSingleRelatedFields((prev) => {
                        return [...prev, fields];
                      });
                    }}
                    setSingleRelatedFieldsFormData={(data) => {
                      setSingleRelatedFieldsFormData((prev) => {
                        return { ...prev, ...data };
                      });
                    }}
                    currentFields={fieldsChanged}
                    label={field.label}
                    name={field.name}
                    relatedParam={field.relatedParam}
                    fields={field.fields}
                    filters={field.filters}
                    url={field.url}
                    handleChange={handleInputChange}
                    defaultValue={
                      field.relatedParam
                        ? fieldsChanged.find(
                          (x) => x.name === field.relatedParam
                        )?.defaultValue
                        : field.defaultValue
                    }
                    relatedParam2={field.relatedParam2}
                    affectsOn={field.affectsOn}
                    parentId={id}
                    err={errors[field.name]}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "textTwoLabel" && (
                  <InputTextTwoLabels
                    alwaysEnabledIf={field.alwaysEnabledIf}
                    getInitialPriceOnFieldChange={
                      field.getInitialPriceOnFieldChange
                    }
                    disabledIfField2={field.disabledIfField2}
                    initialValueParam={field.initialValueParam}
                    initialValueUrl={field.initialValueUrl}
                    getFromValue={field.getFromValue}
                    editId={id}
                    disabledIfField={field.disabledIfField}
                    label={field.label}
                    label2={field.label2}
                    name={field.name}
                    subname={field.subname}
                    type={field.inputType}
                    id={field.id}
                    defaultValue={
                      field.subname
                        ? fieldsChanged.find((x) => x.name === field.subname)
                          ?.defaultValue
                        : field.defaultValue
                    }
                    err={field.err}
                    handleChange={handleInputChange}
                    label2Param={field.label2Param}
                    disabled={field.disabled || isFieldLockedByBilling(field.name)}
                    lazyload={field.lazyload}
                    lazyloadParam={field.lazyloadParam}
                    lazyloadFieldChange={field.lazyloadFieldChange}
                    body={field.body}
                    decimalCount={field.decimalCount}
                    minValue={field.minValue}
                    maxValue={field.maxValue}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "textTwoLabelWithCalc" && (
                  <InputTextTwoLabelsWithCalc
                    quantityField={field.quantityField}
                    alwaysEnabledIf={field.alwaysEnabledIf}
                    getInitialPriceOnFieldChange={
                      field.getInitialPriceOnFieldChange
                    }
                    disabledIfField2={field.disabledIfField2}
                    initialValueParam={field.initialValueParam}
                    initialValueUrl={field.initialValueUrl}
                    getFromValue={field.getFromValue}
                    editId={id}
                    disabledIfField={field.disabledIfField}
                    label={field.label}
                    label2={field.label2}
                    name={field.name}
                    subname={field.subname}
                    type={field.inputType}
                    id={field.id}
                    defaultValue={
                      field.subname
                        ? fieldsChanged.find((x) => x.name === field.subname)
                          ?.defaultValue
                        : field.defaultValue
                    }
                    err={field.err}
                    handleChange={handleInputChange}
                    label2Param={field.label2Param}
                    disabled={field.disabled || isFieldLockedByBilling(field.name)}
                    lazyload={field.lazyload}
                    lazyloadParam={field.lazyloadParam}
                    lazyloadFieldChange={field.lazyloadFieldChange}
                    body={field.body}
                    decimalCount={field.decimalCount}
                    minValue={field.minValue}
                    maxValue={field.maxValue}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "esignature" && (
                  <ESignature
                    id={id}
                    hideButton={field.hideButton}
                    secondButton={field.secondButton}
                    fieldsToValidate={field.fieldsToValidate}
                    formData={formData}
                    validateField={validateField}
                    setErrors={setErrors}
                    callPopUp={callPopUp}
                    dontShowTextWhen={field.dontShowTextWhen}
                    fields={fieldsChanged}
                    disabled={field.disabled}
                    disabledIfField={field.disabledIfField}
                    hideComponent={field.hideComponent}
                    label={field.label}
                    name={field.name}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    triggerProcess={field.trigger}
                    buttonText={field.buttonText}
                    required={requiredFields[field.name]}
                  />
                )}
                {field.type === "fileFetcher" && (
                  <FileFetcher
                    hideIfField={field.hideIfField}
                    params={field.params}
                    filename={field.filename}
                    reservationCode={reservationCode}
                    fields={fieldsChanged}
                    hideComponent={field.hideComponent}
                    listView={field.listView}
                    label={field.label}
                    name={field.name}
                    url={field.url}
                    download_url={field.downloadurl}
                    defaultValue={field.defaultValue}
                    buttonText={field.buttonText}
                    hideButton={field.hideButton}
                    withID={field.withID}
                    id={id}
                    saveChanges={handleSubmit}
                    extraButton={field.extraButton}
                    handleChange={handleInputChange}
                    required={requiredFields[field.name]}
                    callPopUp={callPopUp}
                  />
                )}
                {field.type === "button" && (
                  <AsyncButton
                    currentFields={fieldsChanged}
                    customValidate={field.customValidate}
                    disabled={field.disabled}
                    updateShowFields={updateShowFields}
                    handleSubmit={handleSubmit}
                    fieldsToValidate={field.fieldsToValidate}
                    formData={formData}
                    validateField={validateField}
                    setErrors={setErrors}
                    callPopUp={callPopUp}
                    paramObj={field.paramObj}
                    disabledIfField={field.disabledIfField}
                    ignore={field.ignore}
                    fields={fieldsChanged}
                    activeWhenFieldValues={field.activeWhenFieldValues}
                    withID={field.withID}
                    text={field.text}
                    id={id}
                    errors={errors}
                    param={field.param}
                    apiUrl={field.apiUrl}
                    value={field.value}
                    handleChange={handleInputChange}
                  />
                )}
                {field.type === "statement" && (
                  <CustomerStatement id={id} callPopUp={callPopUp} />
                )}
                {field.type === "temporaryRta" && (
                  <TemporaryRta
                    id={id}
                    callPopUp={callPopUp}
                    fields={fieldsChanged}
                  />
                )}
                {field.type === "contracts_display" && (
                  <ContractsDisplay id={id} />
                )}
                {field.type === "companyVehicles" && (
                  <CompanyVehicles id={id} currentFields={fieldsChanged} />
                )}
                {field.type === "contract-generator" && (
                  <ContractGenerator id={id} currentFields={fieldsChanged} />
                )}
                {field.type === "linkButton" && (
                  <LinkButton
                    label={field.label}
                    name={field.name}
                    err={errors[field.name]}
                    handleChange={handleInputChange}
                    defaultValue={field.defaultValue}
                    disabled={disabled || field.disabled}
                    formType={formType}
                    currentRole={currentRole}
                  />
                )}
              </div>
            );
          })}
          {
            <div
              className={`mt-6 flex items-center justify-end gap-x-6 col-span-full ${hideSubmitActions || stickySubmitActions ? "hidden" : ""
                }`}
            >
              {!onlyForm && !hideCancel && (
                <button
                  type="button"
                  onClick={onCancel}
                  className="text-sm font-semibold leading-6 text-gray-900 relative"
                >
                  <ArrowLeftIcon className="w-7 inline-block" />{" "}
                  <span>Back</span>
                </button>
              )}

              <button
                ref={formRef}
                type="submit"
                onClick={handleSubmit}
                className={`rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${disabled ? "hidden" : ""
                  }`}
              >
                Save
              </button>
            </div>
          }
        </form>
        {_currentTab && _currentTab.hasSummary && (
          <div className="space-y-4 w-[30%]">
            <SummaryList
              options={_currentTab.summaryList}
              handleChange={handleInputChange}
            />
            {_currentTab && _currentTab.hasActions && (
              <ActionsList
                handleSubmit={handleSubmit}
                id={id}
                callPopUp={callPopUp}
                currentFields={fieldsChanged}
                refreshLockStatus={refreshLockStatus}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ReusableForm;
